// React for Website
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
//outsource
import { Row, Col, Button, Divider, Form, Alert, message } from "antd";
import { DOMAIN_WEBSITE } from "../../config/config";
import { MODEL_VOUCHER } from "../../model/voucher";

//components
import VoucherName from "./component/voucher_name";
import VoucherLink from "./component/voucher_link";
import VoucherStatus from "./component/voucher_status";
import VoucherExpiry from "./component/voucher_expiry";
import VoucherTerm from "./component/voucher_term";
import VoucherId from "./component/voucher_id";

//redux
import { useDispatch, useSelector } from "react-redux";
import { snapBranchs, unSnapBranchs } from "../../store/branch/branch.action";
import {
  getDetailPackageById,
  updateVoucherPackage,
} from "../../store/voucher/voucher.action";
import { detailSelector } from "../../store/voucher/voucher.selector";
import { branchsSelector } from "../../store/branch/branch.selector";
import { ownerSelector } from "../../store/role/role.selector";
import { accountSelector } from "../../store/stripe/stripe.selector";

const SectionDetail = () => {
  // -------------------------- VAR --------------------------
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const params = useParams();
  const id = params.id;
  const packageId = params.packageId;

  // -------------------------- STATE --------------------------
  const [shop, setShop] = useState(null);
  const [href, setHref] = useState("");
  const [voucherId, setVoucherId] = useState("");
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const owner = useSelector(ownerSelector);
  const branches = useSelector(branchsSelector);
  const account = useSelector(accountSelector);
  const voucherPackage = useSelector(detailSelector);

  const ownerId = owner?.id || "";
  const term = voucherPackage?.term || "";

  // -------------------------- FUNCTION --------------------------

  const onFinish = (values) => {
    const status = account?.individual?.verification?.status;
    const data = voucherPackage;
    const id = data?.id;

    if (shop && data && status === "verified") {
      setLoading(true);
      const name = shop?.name;
      const shopId = shop?.shopId;
      const branch = shop?.id;
      const update = {
        ...values,
        name,
        shopId,
        branch,
        updateBy: ownerId,
      };

      console.log("update", update);

      if (update) {
        dispatch(
          updateVoucherPackage({ packageId: id, data, update }, (response) => {
            if (response.status === 200) {
              setLoading(false);
              message.success("The Voucher Package was updated!");
              setEdit(false);
            } else {
              setLoading(false);
              message.error(response?.data || "Please try again !");
            }
          })
        );
      }
    } else {
      message.error(
        "Your account hasn't been verified or you dont have a account ! Please try again !"
      );
    }
  };

  const onFinishFailed = (error) => {
    console.log("error", error);
  };

  // -------------------------- EFFECT --------------------------
  //snapBranches
  useEffect(() => {
    dispatch(snapBranchs());

    return () => dispatch(unSnapBranchs());
  }, [dispatch]);

  //Snapthe VoucherPackage by Id
  useEffect(() => {
    if (packageId) {
      dispatch(getDetailPackageById({ packageId }));
    }
  }, [dispatch, packageId]);

  // edit link purchase
  useEffect(() => {
    if (shop) {
      const shopId = shop?.shopId;
      setHref(`${DOMAIN_WEBSITE}/store/${shopId}/${packageId}`);
    }
  }, [shop, packageId]);

  //snap voucher package
  useEffect(() => {
    if (voucherPackage) {
      form.setFieldsValue(voucherPackage);
      form.setFieldsValue({
        expiry: {
          amount: 10,
          step: "years",
        },
      });
    }
  }, [voucherPackage]);

  //snap link purchase
  useEffect(() => {
    if (branches && voucherPackage) {
      const id = voucherPackage?.branch;
      const shop = branches?.find((item) => item?.id === id);
      const shopId = shop?.shopId;
      setShop(shop);
      setHref(`${DOMAIN_WEBSITE}/shop/${shopId}/${packageId}`);
    }
  }, [voucherPackage, branches]);

  //snap term
  useEffect(() => {
    if (term !== "") {
      form.setFieldsValue({ term });
    }
  }, [term]);

  // -------------------------- RENDER --------------------------

  const renderVoucherDetails = () => {
    return (
      <Row>
        <Col lg={8} md={8} sm={24} xs={24}>
          <h1>Campaign Details</h1>
          <p>Basic information about the MKT campaign</p>
        </Col>
        <Col lg={16} md={16} sm={24} xs={24}>
          {renderFormDetail()}
        </Col>
      </Row>
    );
  };

  const renderFormDetail = () => {
    return (
      <Row gutter={[20, 20]}>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherName setShop={setShop} branches={branches} disabled={true} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherId form={form} setVoucherId={setVoucherId} disabled={true} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherLink href={href} disabled={!edit} />
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
          <VoucherStatus disabled={!edit} />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <VoucherExpiry form={form} disabled={true} />
        </Col>
        <Col lg={24} md={24} sm={24} xs={24}>
          <Alert
            message="Please check with the law of your country, as some prohibit the use of expiry dates"
            type="warning"
            showIcon
            closable
          />
        </Col>
      </Row>
    );
  };

  const renderTerms = () => {
    return (
      <Row>
        <Col lg={8} md={8} sm={24} xs={24}>
          <h1>Term Settings</h1>
          <p>Details to help customer make payment</p>
        </Col>
        <Col lg={16} md={16} sm={24} xs={24}>
          {renderTermSetting()}
        </Col>
      </Row>
    );
  };

  const renderTermSetting = () => {
    return (
      <Row>
        <Col lg={24} md={24} sm={24} xs={24}>
          <VoucherTerm shop={shop} form={form} disabledEdit={!edit} />
        </Col>
      </Row>
    );
  };

  const renderButton = () => {
    if (!edit) {
      return (
        <Col align="right" lg={24} md={24} sm={24} xs={24}>
          <Button
            onClick={() => setEdit(true)}
            style={{ width: 100 }}
            type="primary"
          >
            Edit
          </Button>
        </Col>
      );
    }

    return (
      <Col align="right" span={24}>
        <Row style={{ width: 250 }}>
          <Col lg={12} md={12} sm={12} xs={12}>
            <Button
              style={{ width: 120 }}
              type="default"
              loading={loading}
              onClick={() => setEdit(false)}
            >
              Cancel
            </Button>
          </Col>
          <Col lg={12} md={12} sm={12} xs={12}>
            <Button
              form="voucher-edit-form"
              htmlType="submit"
              style={{ width: 120 }}
              type="primary"
              loading={loading}
              //   disabled={disabled}
            >
              Save
            </Button>
          </Col>
        </Row>
      </Col>
    );
  };

  // -------------------------- MAIN --------------------------
  return (
    <Row id="voucher-add">
      {/* <Col lg={24} md={24} sm={24} xs={24}>
        {renderTitle()}
      </Col> */}
      {/* <Divider /> */}
      <Col lg={24} md={24} sm={24} xs={24}>
        <Form
          id="voucher-edit-form"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          type="basic"
          layout="vertical"
          autoComplete="off"
        >
          {renderVoucherDetails()}
          <Divider />
          {renderTerms()}
          {renderButton()}
        </Form>
      </Col>
    </Row>
  );
};

export default SectionDetail;
